<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapname2">Contents</h1>
<h2 class="toc-chap2"><a href="#/xhtml/teil2">Foreword</a></h2>
<h2 class="toc-chap2"><a href="#/xhtml/teil3">Acknowledgements</a></h2>
<h2 class="toc-chap2"><a href="#/xhtml/teil3_1">Notes to the Reader</a></h2>
<h2 class="toc-chap"><a href="#/xhtml/teil4">Chapter One</a></h2>
<h2 class="toc-chap1"><a href="#/xhtml/teil4#ch1">Light Tanks</a></h2>
<h2 class="toc-chap"><span href="#/xhtml/teil5" title="Link target outside of Sample">Chapter Two</span></h2>
<h2 class="toc-chap1"><span href="#/xhtml/teil5#ch2" title="Link target outside of Sample">Early-War Medium Tanks</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/teil6" title="Link target outside of Sample">Chapter Three</span></h2>
<h2 class="toc-chap1"><span href="#/xhtml/teil6#ch3" title="Link target outside of Sample">Late-War Medium Tanks</span></h2>
<h2 class="toc-chap"><span href="#/xhtml/teil7" title="Link target outside of Sample">Chapter Four</span></h2>
<h2 class="toc-chap1"><span href="#/xhtml/teil7#ch4" title="Link target outside of Sample">Heavy Tanks</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// inhalt.vue?56086823